import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../styles/styles';

const { colors, common, spacing, typography } = THEME;

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		margin: '0 auto',
		maxWidth: 600,
	},
	wordmark: {
		color: colors.text.main,
		fontFamily: typography.fontFamilies.sora,
		fontSize: typography.fontSizes.xl,
		fontWeight: typography.fontWeights.bold,
	},
	tabView: {
		width: '100%',
	},
	tabViewTabs: {
		borderBottom: common.border,
		display: 'flex',
	},
	tabViewItem: {
		color: colors.text.light,
		display: 'inline-flex',
		flexBasis: 'auto',
		fontSize: typography.fontSizes.sm,
		gap: spacing.sm,
		height: spacing.xxl,
		paddingBottom: spacing.none,
		paddingLeft: spacing.xl,
		paddingRight: spacing.xl,
		paddingTop: spacing.none,
		textAlign: 'center',
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
	},
	tabItemSelected: {
		borderBottom: `1px solid ${colors.primary.main}`,
	},
	section: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		gap: spacing.md,
		padding: spacing.md,
	},
	inProgressIconContainer: {
		...CssSelectors.allChildren({
			marginTop: spacing.xl,
			opacity: 0.15,
		}),
		background: colors.background.main,
		borderRadius: '50%',
		height: 180,
		margin: `${spacing.xl}px auto ${spacing.xxl}px`,
		textAlign: 'center',
		width: 180,
	},
});
